// Resuelve cuando la página ya ha cargado y el navegador está libre (LDT-718).
// Para lo que la landing no necesita para pintarse: Sentry, el contador de la
// portada… Con un tope de 4 s por si el navegador nunca queda ocioso.
export function afterPageLoad(): Promise<void> {
  return new Promise((resolve) => {
    const idle = () => {
      const ric = (window as Window & { requestIdleCallback?: (cb: () => void, o?: { timeout: number }) => void })
        .requestIdleCallback;
      if (ric) ric(() => resolve(), { timeout: 4000 });
      else setTimeout(resolve, 1);
    };
    if (document.readyState === "complete") idle();
    else window.addEventListener("load", idle, { once: true });
  });
}
